// redux/thunks/thunk-clients.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { User } from "../../models/types";

export interface ClientDataPayload {
  idToken: string;
  clientUserId: string;
}

export const fetchClientData = createAsyncThunk(
  "clients/fetchClientData",
  async ({ idToken, clientUserId }: ClientDataPayload, { rejectWithValue }) => {
    try {
      const url = `https://m01op8z79h.execute-api.us-east-2.amazonaws.com/default/avro-partners?userId=${clientUserId}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: idToken,
        },
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data: User = await response.json();
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
